<app-loader *ngIf="isLoading"></app-loader>
<ng-container *ngIf="!isLoading">
<app-header></app-header>
<section class="breadcrumb" *ngIf="!isLoading">
    <div class="container">
        <div class="row no-gutter">
            <div class="col-md-12 breadcrumb-wrap">
                <p><a (click)="onHome()">Home</a> <img src="./../../../assets/images/rightArrow.svg">
                    <a (click)="onArticle()">Articles</a> <img src="./../../../assets/images/rightArrow.svg"></p>
                <h2>{{articleDataAll?.title}}</h2>
            </div>
        </div>
    </div>
</section>

<div class="parallex" *ngIf="!isLoading">
    <div class="container">
        <div class="article-container">
            <div class="image-container">
                <img [src]="articleDataAll?.thumbnail" alt="Article Image">
                <div class="badge-mobile">{{articleDataAll?.articleCategoryType}}</div>
                <!-- <div class="meta">
                    <p class="date">January 8, 2025</p>
                    <p class="author">Author: <span>Catholic Legacy</span></p>
                </div> -->
            </div>
            <div class="details-container">
                <div class="info-container">
                <div class="badge">{{articleDataAll?.articleCategoryType}}</div>
                <div class="info">
                    <p class="date">{{articleDataAll?.created_at | date}}</p>
                    <p class="author">Author: <br> <span>{{articleDataAll?.authorName}}</span></p>
                    <p class="readingTime">Reading Time: <br><span>{{articleDataAll?.readTime}}</span></p>
                </div>
                <div class="left-btn-container">
                    <button class="btn-share">
                        <div class="btn-content">
                          <span class="btn-text">Share</span>
                          <span class="btn-icon">
                            <svg t="1580465783605" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="9773" width="18" height="18">
                            <path
                                d="M767.99994 585.142857q75.995429 0 129.462857 53.394286t53.394286 129.462857-53.394286 129.462857-129.462857 53.394286-129.462857-53.394286-53.394286-129.462857q0-6.875429 1.170286-19.456l-205.677714-102.838857q-52.589714 49.152-124.562286 49.152-75.995429 0-129.462857-53.394286t-53.394286-129.462857 53.394286-129.462857 129.462857-53.394286q71.972571 0 124.562286 49.152l205.677714-102.838857q-1.170286-12.580571-1.170286-19.456 0-75.995429 53.394286-129.462857t129.462857-53.394286 129.462857 53.394286 53.394286 129.462857-53.394286 129.462857-129.462857 53.394286q-71.972571 0-124.562286-49.152l-205.677714 102.838857q1.170286 12.580571 1.170286 19.456t-1.170286 19.456l205.677714 102.838857q52.589714-49.152 124.562286-49.152z"
                                p-id="9774" fill="#ffffff"></path>
                        </svg>
                          </span>
                        </div>
                        <ul class="social-icons">
                            <li>
                                Share
                              </li>
                          <li>
                            <a (click)="share('facebook')">
                              <img class="social-icon" src="./assets/images/fb-icon-white.svg">
                            </a>
                          </li>
                          <li>
                            <a (click)="share('linkedin')">
                              <img class="social-icon" src="./assets/images/ln-icon-white.svg">
                            </a>
                          </li>
                          <li>
                            <a (click)="share('twitter')">
                              <img class="social-icon" src="./assets/images/x-icon-white.svg">
                            </a>
                          </li>
                        </ul>
                      </button>
    
                </div>
                </div>
                <div class="article-text" [innerHTML]="renderHTmlTags(articleDataAll?.description)">
                    <!-- <p>
                        Vivamus non porttitor diam. Duis vitae rutrum ante. Sed condimentum facilisis sodales.
                        Fusce consectetur ut lectus sit amet pharetra. Proin a ipsum luctus justo ullamcorper auctor.
                        Duis diam nisi, tempor vitae tellus ut, ultrices mollis elit. Nunc odio felis,
                        vulputate nec augue at, cursus dignissim orci. Nulla in tempor ex, vitae hendrerit felis.
                        Nulla facilisi. Maecenas fringilla laoreet volutpat. Curabitur mauris sem, faucibus non diam eget,
                        pretium mattis turpis.
                    </p> -->
                    <!-- {{articleDataAll.description}}  -->
                </div>
            </div>
        </div>

        <div class="faqs" *ngIf="faqData?.length>0">
            <div class="container container-mobile">
                <h2 class="faq-heading">FAQs</h2>
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item" *ngFor="let data of faqData; index as i">
                        <h2 class="accordion-header" id="{{data._id}}">
                            <button class="accordion-button" type="button" [class.collapsed]="data.isCollapsed"
                                (click)="toggleAccordion(data)">
                                <span>{{data.question}}</span>
                            </button>
                        </h2>
                        <div [attr.id]="'collapse' + data._id + i" class="accordion-collapse collapse"
                            [class.show]="!data.isCollapsed" [attr.aria-labelledby]="data._id"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <!-- Use *ngIf to check if data.answer exists before rendering -->
                                <p *ngIf="data.answer" [innerHTML]="data.answer"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="resources-wrap-new" *ngIf="!noArticle && !isLoading">
            <div class="container article-slider container-mobile" [ngClass]="{'addMargin': articleData?.length <= 2}">
                <div class="article-header">Related Articles</div>
                <owl-carousel-o [options]="customOptions" id="resourcesSlidernew">  
                    <ng-container *ngFor="let data of articleData">
                      <ng-template carouselSlide [id]="data._id">
                        <div class="video-wrap" (click)="readMore(data)">
                            <a target="_blank" (click)="readMore(data)"><img [src]="data.thumbnail" alt="Resources"></a>
                            <div class="realted-article-badge">{{data.articleCategoryType || '-'}}</div>
                        </div>
                        <h2><a target="_blank" [title]="data?.title" (click)="readMore(data)" class="link-unstyled">{{data?.title}}</a></h2>
                        <!-- <p class="titleDesc" [title]="data.description">{{ (data.description.length > 90) ? (data.description | slice:0:90) + '...' : data.description }}</p> -->
                         <span class="article-date">{{data?.created_at | date}}&nbsp;&nbsp; &nbsp;{{data.readTime || ''}}<ng-container *ngIf="data.readTime"> Read</ng-container></span>
                         <p class="titleDesc paraDesc" (click)="readMore(data)" ><a  target="_blank" class="link-unstyled">
                            {{ removeHtmlTags(data.description) }}
                            <span  class="article-description">{{removeHtmlTags(data.description)}}</span></a></p>
                          <span class="read-more" (click)="readMore(data)">Read More</span>
                      </ng-template>
                    </ng-container>              
                </owl-carousel-o>
            </div>
        </div>
        
    </div>
</div>
<app-footer></app-footer>
<button class="scroll-to-top btn-top" (click)="scrollToTop()" *ngIf="showScroll">
    <img src="../../../../assets/images/Arrow-up.svg">
</button>
</ng-container>
